import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-lg-4 mb-3" }
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "all-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "all-tab",
  tabindex: "0"
}
const _hoisted_6 = { class: "default-table-area all-products" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle" }
const _hoisted_9 = { class: "text-body" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "ms-2 ps-1" }
const _hoisted_12 = { class: "fw-medium fs-14" }
const _hoisted_13 = { class: "fs-12 text-body" }
const _hoisted_14 = { class: "text-secondary" }
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "text-secondary" }
const _hoisted_17 = { class: "text-secondary" }
const _hoisted_18 = { class: "text-secondary" }
const _hoisted_19 = { class: "text-secondary" }
const _hoisted_20 = { class: "d-flex align-items-center gap-1" }
const _hoisted_21 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_22 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_23 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_24 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_25 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_26 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_27 = {
  class: "tab-pane fade",
  id: "published-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "published-tab",
  tabindex: "0"
}
const _hoisted_28 = { class: "default-table-area all-products" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table align-middle" }
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "ms-2 ps-1" }
const _hoisted_34 = { class: "fw-medium fs-14" }
const _hoisted_35 = { class: "fs-12 text-body" }
const _hoisted_36 = { class: "text-secondary" }
const _hoisted_37 = { class: "text-secondary" }
const _hoisted_38 = { class: "text-secondary" }
const _hoisted_39 = { class: "text-secondary" }
const _hoisted_40 = { class: "text-secondary" }
const _hoisted_41 = { class: "text-secondary" }
const _hoisted_42 = { class: "d-flex align-items-center gap-1" }
const _hoisted_43 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_44 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_45 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_46 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_47 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_48 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_49 = {
  class: "tab-pane fade",
  id: "draft-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "draft-tab",
  tabindex: "0"
}
const _hoisted_50 = { class: "default-table-area all-products" }
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table align-middle" }
const _hoisted_53 = { class: "text-body" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "ms-2 ps-1" }
const _hoisted_56 = { class: "fw-medium fs-14" }
const _hoisted_57 = { class: "fs-12 text-body" }
const _hoisted_58 = { class: "text-secondary" }
const _hoisted_59 = { class: "text-secondary" }
const _hoisted_60 = { class: "text-secondary" }
const _hoisted_61 = { class: "text-secondary" }
const _hoisted_62 = { class: "text-secondary" }
const _hoisted_63 = { class: "text-secondary" }
const _hoisted_64 = { class: "d-flex align-items-center gap-1" }
const _hoisted_65 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_66 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_67 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_68 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_69 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_70 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CommonPaginationTwo = _resolveComponent("CommonPaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("ul", {
        class: "nav nav-tabs border-0 gap-3 mb-lg-4 mb-3 seller-tabs",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-0 bg-body-bg text-secondary fw-medium fs-16 rounded-3 py- px-md-5 px-4 active",
            id: "all-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#all-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "all-tab-pane",
            "aria-selected": "true"
          }, [
            _createElementVNode("span", { class: "d-inline-block py-1" }, "All Products")
          ])
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-0 bg-body-bg text-secondary fw-medium fs-16 rounded-3 py- px-md-5 px-4",
            id: "published-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#published-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "published-tab-pane",
            "aria-selected": "false"
          }, [
            _createElementVNode("span", { class: "d-inline-block py-1" }, "Published Products")
          ])
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-0 bg-body-bg text-secondary fw-medium fs-16 rounded-3 py- px-md-5 px-4",
            id: "draft-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#draft-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "draft-tab-pane",
            "aria-selected": "false"
          }, [
            _createElementVNode("span", { class: "d-inline-block py-1" }, "Draft Products")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _createVNode(_component_RouterLink, {
          to: "/ecommerce/create-product",
          class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-18 me-1" }),
              _createElementVNode("span", null, "Add New Product")
            ], -1)
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "ID"),
                    _createElementVNode("th", { scope: "col" }, "Product"),
                    _createElementVNode("th", { scope: "col" }, "Category"),
                    _createElementVNode("th", { scope: "col" }, "Price"),
                    _createElementVNode("th", { scope: "col" }, "Order"),
                    _createElementVNode("th", { scope: "col" }, "Stock"),
                    _createElementVNode("th", { scope: "col" }, "Amount"),
                    _createElementVNode("th", { scope: "col" }, "Rating"),
                    _createElementVNode("th", { scope: "col" }, "Status"),
                    _createElementVNode("th", { scope: "col" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_9, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/product-details",
                          class: "d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: item.product.image,
                              class: "wh-40 rounded-3",
                              alt: "product-1"
                            }, null, 8, _hoisted_10),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("h6", _hoisted_12, _toDisplayString(item.product.title), 1),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(item.product.date), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.category), 1),
                      _createElementVNode("td", _hoisted_15, "$" + _toDisplayString(item.price), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.order), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.stock.count), 1),
                      _createElementVNode("td", _hoisted_18, "$" + _toDisplayString(item.amount), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.rating), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                        }, _toDisplayString(item.status), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", _hoisted_21, [
                            _createElementVNode("i", _hoisted_22, _toDisplayString(item.action.view), 1)
                          ]),
                          _createElementVNode("button", _hoisted_23, [
                            _createElementVNode("i", _hoisted_24, _toDisplayString(item.action.edit), 1)
                          ]),
                          _createElementVNode("button", _hoisted_25, [
                            _createElementVNode("i", _hoisted_26, _toDisplayString(item.action.delete), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_component_CommonPaginationTwo, {
              items: "10",
              total: _ctx.items.length
            }, null, 8, ["total"])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "ID"),
                    _createElementVNode("th", { scope: "col" }, "Product"),
                    _createElementVNode("th", { scope: "col" }, "Category"),
                    _createElementVNode("th", { scope: "col" }, "Price"),
                    _createElementVNode("th", { scope: "col" }, "Order"),
                    _createElementVNode("th", { scope: "col" }, "Stock"),
                    _createElementVNode("th", { scope: "col" }, "Amount"),
                    _createElementVNode("th", { scope: "col" }, "Rating"),
                    _createElementVNode("th", { scope: "col" }, "Status"),
                    _createElementVNode("th", { scope: "col" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishedItems, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_31, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/product-details",
                          class: "d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: item.product.image,
                              class: "wh-40 rounded-3",
                              alt: "product-1"
                            }, null, 8, _hoisted_32),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("h6", _hoisted_34, _toDisplayString(item.product.title), 1),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(item.product.date), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(item.category), 1),
                      _createElementVNode("td", _hoisted_37, "$" + _toDisplayString(item.price), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(item.order), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(item.stock.count), 1),
                      _createElementVNode("td", _hoisted_40, "$" + _toDisplayString(item.amount), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(item.rating), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                        }, _toDisplayString(item.status), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("button", _hoisted_43, [
                            _createElementVNode("i", _hoisted_44, _toDisplayString(item.action.view), 1)
                          ]),
                          _createElementVNode("button", _hoisted_45, [
                            _createElementVNode("i", _hoisted_46, _toDisplayString(item.action.edit), 1)
                          ]),
                          _createElementVNode("button", _hoisted_47, [
                            _createElementVNode("i", _hoisted_48, _toDisplayString(item.action.delete), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_component_CommonPaginationTwo, {
              items: "10",
              total: _ctx.publishedItems.length
            }, null, 8, ["total"])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("table", _hoisted_52, [
                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "ID"),
                    _createElementVNode("th", { scope: "col" }, "Product"),
                    _createElementVNode("th", { scope: "col" }, "Category"),
                    _createElementVNode("th", { scope: "col" }, "Price"),
                    _createElementVNode("th", { scope: "col" }, "Order"),
                    _createElementVNode("th", { scope: "col" }, "Stock"),
                    _createElementVNode("th", { scope: "col" }, "Amount"),
                    _createElementVNode("th", { scope: "col" }, "Rating"),
                    _createElementVNode("th", { scope: "col" }, "Status"),
                    _createElementVNode("th", { scope: "col" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draftItems, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_53, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/product-details",
                          class: "d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: item.product.image,
                              class: "wh-40 rounded-3",
                              alt: "product-1"
                            }, null, 8, _hoisted_54),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("h6", _hoisted_56, _toDisplayString(item.product.title), 1),
                              _createElementVNode("span", _hoisted_57, _toDisplayString(item.product.date), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_58, _toDisplayString(item.category), 1),
                      _createElementVNode("td", _hoisted_59, "$" + _toDisplayString(item.price), 1),
                      _createElementVNode("td", _hoisted_60, _toDisplayString(item.order), 1),
                      _createElementVNode("td", _hoisted_61, _toDisplayString(item.stock.count), 1),
                      _createElementVNode("td", _hoisted_62, "$" + _toDisplayString(item.amount), 1),
                      _createElementVNode("td", _hoisted_63, _toDisplayString(item.rating), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                        }, _toDisplayString(item.status), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("button", _hoisted_65, [
                            _createElementVNode("i", _hoisted_66, _toDisplayString(item.action.view), 1)
                          ]),
                          _createElementVNode("button", _hoisted_67, [
                            _createElementVNode("i", _hoisted_68, _toDisplayString(item.action.edit), 1)
                          ]),
                          _createElementVNode("button", _hoisted_69, [
                            _createElementVNode("i", _hoisted_70, _toDisplayString(item.action.delete), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_component_CommonPaginationTwo, {
              items: "10",
              total: "30"
            })
          ])
        ])
      ])
    ])
  ]))
}